<template>
  <div class="pl-2 pr-2">
    <div class="invoice-tracker">
      <b-card class="mb-2">
        <b-row>
          <b-col>
            <h4>Invoices Report</h4>
          </b-col>
        </b-row>
        <b-row>
          <b-col v-if="true" ref="chartBox" cols="12">
            <Bar :chart-options="this.chart.options" :chart-data="this.chart.data" :chart-id="chartId"
              :dataset-id-key="datasetIdKey" :plugins="plugins" :css-classes="cssClasses" :styles="styles"
              :key="this.componentKey" />
            <div class="year-navigator">
              <button class="nav-button" @click="previousYear">&lt;</button>
              <span class="current-year">{{ currentYear }}</span>
              <button class="nav-button" @click="nextYear">&gt;</button>
            </div>
          </b-col>
        </b-row>
      </b-card>

      <b-card class="mb-2" ref="search">
        <b-row>
          <b-col>
            <h4>Search Invoices</h4>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="3">
            <label>Client</label>
            <b-form-select v-model="selectedCustomerId">
              <option v-for="customer in customers" :key="customer.id" :value="customer.id">{{ customer.name }}</option>
            </b-form-select>
          </b-col>
          <b-col cols="3">
            <label>Vendor</label>
            <b-form-select v-model="selectedVendorId">
              <option v-for="vendor in vendors" :key="vendor.id" :value="vendor.id">{{ vendor.name }}</option>
            </b-form-select>
          </b-col>
          <b-col cols="3">
            <label>Date </label>
            <date-range-picker @onDateSelected="onDateSelected" ref="datePickerRef" />
          </b-col>
          <b-col cols="3">
            <label>Status</label>
            <b-form-select v-model="selectedStatus">
              <option value="Queried">Queried</option>
              <option value="Pending">Pending</option>
              <option value="Accepted">Accepted</option>
              <option value="Rejected">Rejected</option>
              <option value="AR Exported">AR Exported</option>
              <option value="AP Exported">AP Exported</option>
              <option value="AR Invoiced">AR Invoiced</option>
              <option value="AP Processed">AP Processed</option>
              <option value="AR Exported - AP Processed">AR Exported - AP Processed</option>
              <option value="AR Invoiced - AP Exported">AR Invoiced - AP Exported</option>
              <option value="Completed">Completed</option>

              <option value="Returned">Returned</option>
              <option value="Credit Note - AP Processed">Credit Note - AP Processed</option>
              <option value="Credit Note - AP Exported">Credit Note - AP Exported</option>
              <option value="AR Invoiced - Unreleased">AR Invoiced - Unreleased</option>
              <option value="AR Exported - Unreleased">AR Exported - Unreleased</option>
            </b-form-select>
          </b-col>
          <b-col cols="3">
            <label>Load Confirmation No.</label>
            <b-form-input v-model="orderIdQuery"></b-form-input>
          </b-col>
          <b-col cols="3">
            <label>Bulk Order No. </label>
            <b-form-input v-model="bulkOrderQuery"></b-form-input>
          </b-col>
          <b-col cols="3">
            <label>Vehicle Reg.</label>
            <b-form-input v-model="vehicleRegQuery"></b-form-input>
          </b-col>
          <b-col cols="3">
            <label>Purchase Order No. </label>
            <b-form-input v-model="purchaseOrderQuery"></b-form-input>
          </b-col>
          <b-col v-if="currentTab == 'receivable'" cols="3">
            <label>Sales Order Reference No.</label>
            <b-form-input v-model="salesOrderReferenceNumber"></b-form-input>
          </b-col>
          <b-col v-if="currentTab == 'payable'" cols="3">
            <label>Purchase Order Reference No.</label>
            <b-form-input v-model="purchaseOrderReferenceNumber"></b-form-input>
          </b-col>

          <b-col cols="3">
            <label>Weighbridge Slip No.</label>
            <b-form-input v-model="weighbrideSlipNumber"></b-form-input>
          </b-col>
          <b-col cols="3">
            <label>Order Key</label>
            <b-form-input v-model="orderKeyQuery"></b-form-input>
          </b-col>
        </b-row>

        <hr class="mx-3">
        <b-row>
          <b-col>
            <div class="d-flex justify-content-end">
              <div>
                <b-button ariant="primary" squared class="ml-2" @click="searchAll">Search</b-button>
              </div>
              <div>
                <b-button variant="outline-red" squared class="ml-2" @click="clearSearch">Clear</b-button>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-card>

      <div class="tabs">
        <button :class="{ active: currentTab === 'receivable' }" @click="changeTab('receivable')">Accounts
          Receivable</button>
        <button :class="{ active: currentTab === 'payable' }" @click="changeTab('payable')">Accounts
          Payable</button>
        <button :class="{ active: currentTab === 'completed' }" @click="changeTab('completed')">Completed
          Invoices</button>
      </div>

      <b-card class="table-card">
        <b-col>
          <div :class="{ 'floating-buttons': !isTabsVisible }">
            <h3>
              <template v-if="currentTab == 'payable'">Accounts Payable</template>
              <template v-else-if="currentTab == 'receivable'">Accounts Receivable</template>
              <template v-else-if="currentTab == 'completed'">Completed</template>
            </h3>

            <div v-if="currentTab != 'completed'">
              <b-button v-if="currentTab == 'receivable'" ariant="primary" squared @click="bulkEditStatus"
                :disabled="disableBulkEdit || isExporting || isExportingMultiLine">Edit
                Status</b-button>
              <b-button ariant="primary" class="ml-2" squared @click="exportToPastel(false);"
                :disabled="isExporting || disableExport || isExportingMultiLine">{{ isExporting &&
                  disableMultipleExport ?
                  "Exporting..."
                  : "Export" }}</b-button>
              <b-button v-if="currentTab == 'receivable'" ariant="primary" class="ml-2" squared
                @click="exportToPastel(true);"
                :disabled="disableMultipleExport || isExportingMultiLine || isExporting">{{
                  isExportingMultiLine &&
                    !disableMultipleExport ? "Exporting..."
                    :
                    "Export Multi Line"
                }}</b-button>
              <b-button v-if="currentTab == 'receivable'" ariant="primary" class="ml-2" squared
                @click="exportToExisting()"
                :disabled="disableAddToExistingExport || isExportingMultiLine || isExporting">{{
                  !disableAddToExistingExport ?
                    "Export To Existing Invoice"
                    :
                    "Export To Existing Invoice"
                }}</b-button>

              <b-button variant="outline-secondary" squared class="ml-2" @click="exportToExcel"
                :disabled="isExportingToExcel">
                {{ !isExportingToExcel ? "Export Excel Sheet" : "Exporting Sheet..." }} </b-button>

              <b-button variant="outline-secondary" squared class="ml-2" @click="selectAll">Select All</b-button>

              <b-button v-if="selectedRows.length > 1" variant="outline-red" squared class="ml-2"
                @click="clearSelect">Deselect
                All</b-button>
            </div>
          </div>

          <div class="table-container" @contextmenu.prevent="showContextMenu">
            <b-table striped hover sort-icon-left :headers="tableData.dataSource.tableColumns"
              :sort-desc.sync="sortDesc" :sort-by.sync="sortBy" :items="tableData.dataSource"
              :fields="tableData.tableColumns" :busy="tableData.isLoading" selectable select-mode="multi"
              @row-selected="onRowSelected" :selected-rows="selectedRows" ref="invoicesTable" show-empty
              :per-page="tableData.resultsPerPage" @row-contextmenu="onRowRightClick">
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner style="width: 3rem; height: 3rem;"></b-spinner>
                </div>
              </template>

              <template #empty>
                <div class="text-center my-2">
                  <span v-if="!tableData.isLoading && tableData.dataSource.length === 0">No results found.</span>
                  <span v-else>No data available.</span>
                </div>
              </template>

              <template #head()="{ label, field: { key, sortable } }">
                {{ label }}
                <template v-if="sortable">
                  <template>
                    <b-icon v-if="sortBy !== key" icon="arrow-down-up"></b-icon>
                    <b-icon v-else-if="sortDesc" icon="arrow-down"></b-icon>
                    <b-icon v-else icon="arrow-up"></b-icon>
                  </template>
                </template>
              </template>

              <template #cell(index)="data">
                {{ data.index + 1 + (currentPage - 1) * tableData.resultsPerPage }}
              </template>

              <template #cell(icon)="row">
                <img width="50" :src="url + row.item.icon" />
              </template>
              <template #cell(serviceDate)="data">
                {{ formatDate(data.value) }}
              </template>
              <template #cell(dit)="data">
                <div style="text-align: center;">
                  R {{ data.value.toLocaleString('en-US') }}
                </div>
              </template>
              <template #cell(apInvoiceTotal)="row">
                <div>
                  R {{ (row.item.ogCostPrice * row.item.billOnQuantity).toLocaleString('en-US') }}
                </div>
              </template>
              <template #cell(arInvoiceTotal)="row">
                <div style="text-align: center;">
                  R {{ (row.item.ogSalesPrice > 0 ? row.item.ogSalesPrice * row.item.billOnQuantity :
                    row.item.salesPrice * row.item.billOnQuantity).toLocaleString('en-US') }}
                </div>
              </template>

              <template #cell(status)="data">
                <div
                  v-if="selectedRow != null && selectedLoadToEdit != null && data.item.loadConfirmationNumber == selectedLoadToEdit">
                  <b-form-select v-model="selectedRow.status">
                    <option value="Default" disabled>Please Select Status</option>
                    <option value="Queried">Queried</option>
                    <option value="Pending">Pending</option>
                    <option value="Accepted">Accepted</option>
                    <option value="Rejected">Rejected</option>
                    <option value="AR Exported">AR Exported</option>
                    <option value="AP Exported">AP Exported</option>
                    <option value="AR Invoiced">AR Invoiced</option>
                    <option value="AP Processed">AP Processed</option>
                    <option value="AR Exported - AP Processed">AR Exported - AP Processed</option>
                    <option value="AR Invoiced - AP Exported">AR Invoiced - AP Exported</option>
                    <option value="Completed">Completed</option>
                  </b-form-select>
                </div>
                <div v-else>
                  {{ data.value }}
                </div>
              </template>
              <template #cell(pastelSalesOrderReference)="data">
                <div
                  v-if="selectedRow != null && selectedLoadToEdit != null && data.item.loadConfirmationNumber == selectedLoadToEdit">
                  <input v-model="selectedRow.pastelSalesOrderReference">
                </div>
                <div v-else style="text-decoration: underline;" @click.prevent="viewOrder(data.value)">
                  {{ data.value }}
                </div>
              </template>
              <template #cell(pastelPurchaseOrderReference)="data">
                <div
                  v-if="selectedRow != null && selectedLoadToEdit != null && data.item.loadConfirmationNumber == selectedLoadToEdit">
                  <input v-model="selectedRow.pastelPurchaseOrderReference">
                </div>
                <div v-else>
                  {{ data.value }}
                </div>
              </template>
              <template #cell(actions)="row">
                <b-row>
                  <b-button @click="toggleViewDocument(row.item)" size="sm" class="btn-icon">
                    <b-icon-eye></b-icon-eye>
                  </b-button>
                </b-row>
              </template>
            </b-table>
          </div>
          <b-row align-h="center" v-if="tableData.dataSource.length > 0">
            <b-pagination v-model="currentPage" :total-rows="totalNoDocuments" :per-page="tableData.resultsPerPage"
              aria-controls="searchDocument" @change="handlePageChange"></b-pagination>
          </b-row>
        </b-col>
      </b-card>
      <b-modal v-model="displayViewDocument" title="Invoice Details" size="xl" hide-footer>
        <OrderViewer :orderid="selectedInvoiceId" :currentTab="currentTab" />
      </b-modal>
      <b-modal v-model="displayBulkEdit" title="Bulk Edit Status" size="xl" hide-footer>
        <BulkEditStatus :invoices="selectedRows" />
      </b-modal>
      <b-modal v-model="displayExportToExistingInvoiceModal"
        :title="'Accounts ' + capitalizeFirstLetter(currentTab) + ' Export To Existing Invoice'" size="xl" hide-footer>
        <ExportedPastelInvoices :invoices="selectedRows" :pastelInvoices="pastelInvoices" :currentTab="currentTab" />
      </b-modal>
      <b-modal v-model="displayExportedPastelInvoicesReadOnlyModal" title='Exported Order Details' size="xl"
        hide-footer>
        <ExportedPastelInvoicesReadOnly :Reference="selectedOrderReferenceNumber" />
      </b-modal>
    </div>
    <ContextMenu ref="contextMenu" @select="handleMenuAction" />
  </div>
</template>

<script>
import 'vue-cal/dist/vuecal.css'
import { Bar } from 'vue-chartjs/legacy'
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'
import DateRangePicker from "./DateRangePicker.vue";

import api from "../api";
import OrderViewer from './OrderViewer.vue';
import BulkEditStatus from './BulkEditStatus.vue';
import ExportedPastelInvoices from './ExportedPastelInvoices.vue';
import ExportedPastelInvoicesReadOnly from './ExportedPastelInvoicesReadOnly.vue';


import eventBus from '../eventBus';
import ContextMenu from './ContextMenu.vue';
// import * as signalR from "@microsoft/signalr";

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

export default {
  components: { DateRangePicker, Bar, OrderViewer, BulkEditStatus, ExportedPastelInvoices, ExportedPastelInvoicesReadOnly, ContextMenu },
  name: "InvoiceTracker",
  props: {
    chartId: {
      type: String,
      default: 'Invoice Status'
    },
    datasetIdKey: {
      type: String,
      default: 'label'
    },
    width: {
      type: Number,
      default: 800
    },
    height: {
      type: Number,
      default: 230
    },
    cssClasses: {
      default: '',
      type: String
    },
    styles: {
      type: Object,
      default: () => {

      }
    },
    plugins: {
      type: Object,
      default: () => {
      }
    }
  },
  computed: {
    //Forced to implement minDate
    minDate() {
      return new Date().subtractDays(365 * 10)
    },
    maxDate() {
      return new Date()
    },
    graphHeightCalc() {
      if (this.mobileAndTabletCheck()) {
        return screen.height * 0.2
      }

      return 230
    },
    graphWidthCalc() {
      if (screen.width < 550) {
        return (screen.width) * 0.8
      } else if (screen.width < 1000) {
        return (screen.width - 260) * 0.9
      }

      return (800)
    },
    CanViewAll() {
      return true;
      // return (this.user.role.Name === "LcsUser")
    }

  },
  data: () => ({
    selectedOrderReferenceNumber: null,
    connection: null,
    messages: [],
    currentYear: new Date().getFullYear(),
    isTabsVisible: true,
    currentTab: 'receivable',
    availableDates: null,
    selectedVendorId: null,
    selectedCustomerId: null,
    selectedStatus: "",
    orderIdQuery: null,
    purchaseOrderQuery: null,
    vehicleRegQuery: null,
    orderKeyQuery: null,
    bulkOrderQuery: null,
    salesOrderReferenceNumber: null,
    purchaseOrderReferenceNumber: null,
    weighbrideSlipNumber: null,
    selectedRow: null,
    ogSelectedRow: null,
    selectedLoadToEdit: null,
    disableRightClick: false,
    selectedRows: [],
    pastelInvoices: [],
    selectedInvoiceId: 0,
    vendors: [],
    customers: [],
    displayViewDocument: false,
    disableBulkEdit: true,
    displayBulkEdit: false,
    displayExportToExistingInvoiceModal: false,
    displayExportedPastelInvoicesReadOnlyModal: false,
    user: null,
    hidden: false,
    disableExport: true,
    disableMultipleExport: true,
    disableAddToExistingExport: true,
    startDate: null,
    endDate: null,
    isExporting: false,
    isExportingMultiLine: false,
    isExportingToExcel: false,
    ogTableData: {},
    sortIconNeutral:
      "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='101' height='101' view-box='0 0 101 101' preserveAspectRatio='none'%3e%3cpath fill='black' opacity='.3' d='M51 1l25 23 24 22H1l25-22zM51 101l25-23 24-22H1l25 22z'/%3e%3c/svg%3e",
    sortIconDesc:
      "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='101' height='101' view-box='0 0 101 101' preserveAspectRatio='none'%3e%3cpath fill='black' d='M51 1l25 23 24 22H1l25-22z'/%3e%3cpath fill='black' opacity='.3' d='M51 101l25-23 24-22H1l25 22z'/%3e%3c/svg%3e",
    sortIconAsc:
      "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='101' height='101' view-box='0 0 101 101' preserveAspectRatio='none'%3e%3cpath fill='black' opacity='.3' d='M51 1l25 23 24 22H1l25-22z'/%3e%3cpath fill='black' d='M51 101l25-23 24-22H1l25 22z'/%3e%3c/svg%3e",
    sortBy: null,
    sortDesc: false,
    // https://codepen.io/Hiws/pen/jOqjwPr
    tableData: {
      resultsPerPage: 50,
      currentPage: 1,
      dataSource: [],
      isLoading: false,
      tableColumns: [
        { label: '#', key: 'index', tdClass: '', sortable: true, numeric: true, html: false, visible: true },
        { label: "Customer", sortable: true, key: "customerName", numeric: false, html: false, visible: true },
        { label: "Customer Code", key: "customerCode", numeric: false, html: false, sortable: true, visible: true },
        { label: "Vendor", key: "vendorName", numeric: false, html: false, sortable: true, visible: true },
        { label: "Vendor Code", key: "vendorCode", numeric: false, html: false, sortable: true, visible: true },
        { label: "Service Date", key: "serviceDate", numeric: false, html: false, sortable: true, visible: true },
        { label: "Pickup Location", key: "pickUpLocation", numeric: false, html: false, sortable: true, visible: true },
        { label: "Droppoff Location", key: "dropOffLocation", numeric: false, html: false, sortable: true, visible: true },
        { label: "Bulk Order", key: "bulkOrderNumber", numeric: false, html: false, sortable: true, visible: true },
        { label: "Load Confirmation", key: "orderId", numeric: false, html: false, sortable: true, visible: true },
        { label: "Order Key", key: "orderKey", numeric: false, html: false, sortable: true, visible: true },
        { label: "Vehicle Reg", key: "vehicleReg", numeric: false, html: false, sortable: true, visible: true },
        { label: "Purchase Order", key: "purchaseOrderNumber", numeric: false, html: false, sortable: true, visible: true },
        { label: "Deemed Invoice Total", key: "dit", numeric: true, html: false, sortable: true, visible: true },
        { label: "Tonnage", key: "billOnQuantity", numeric: false, html: false, sortable: true, visible: true },
        { label: "AR Invoice Total", key: "arInvoiceTotal", numeric: true, html: false, sortable: true, visible: true },
        { label: "AP Invoice Total", key: "apInvoiceTotal", numeric: true, html: false, sortable: true, visible: true },
        { label: "Status", key: "status", sortable: true, visible: true, tdClass: 'admin-inline-status' },
        { label: "SO Reference", key: "pastelSalesOrderReference", sortable: true, visible: false, tdClass: 'admin-inline-reference' },
        { label: "PO Reference", key: "pastelPurchaseOrderReference", sortable: true, visible: false, tdClass: 'admin-inline-reference' },
        { label: "Weighbridge Slip", key: "weighbridgeSlipNumber", sortable: true, visible: true },
        { label: 'Action', key: 'actions', sortable: false, tdClass: '', visible: true }
      ]
    }
    ,
    totalNoDocuments: 0,
    currentPage: 1,
    chart: {
      data: {
        labels: [],
        datasets: []
      },
      options: {
        responsive: false,
        scales: {
          y: {
            ticks: {
              callback: function (value) {
                return new Intl.NumberFormat('en-ZA', {
                  style: 'currency',
                  currency: 'ZAR'
                }).format(value);
              }
            }
          }
        },
      },
      datasetColor: {
        Accepted: "#4CAF50",
        Pending: "#FFC107",
        Rejected: "#F44336",
        Queried: "#00BCD4",
        Completed: "#8BC34A",
        "AR Exported": "#2E86C1",
        "AP Exported": "#D35400",
        "AR Invoiced": "#9B59B6",
        "AP Processed": "#E74C3C",
        "AR Invoiced - AP Processed": "#8BC34A",
        "AR Exported - AP Processed": "#9E9E9E",
        "AR Invoiced - AP Exported": "#3F51B5"
      },
      datasetLabels: {
        Accepted: "Accepted",
        "AP Exported": "AP Exported",
        "AP Processed": "AP Processed",
        "AR Exported": "AR Exported",
        "AR Exported - AP Processed": "AR Exported - AP Processed",
        "AR Invoiced": "AR Invoiced",
        "AR Invoiced - AP Exported": "AR Invoiced - AP Exported",
        "AR Invoiced - AP Processed": "AR Invoiced - AP Processed",
        Completed: "Completed",
        Pending: "Pending",
        Queried: "Queried",
        Rejected: "Rejected",
      }
    },
    componentKey: 0,
    selectedDate: null
  }),
  watch: {
    '$route'() {
      this.hidden = this.mobileAndTabletCheck();
    },
    sortBy() {
      this.searchAll();
    },
    sortDesc() {
      this.searchAll();
    }
  },
  mounted() {
    // this.connection = new signalR.HubConnectionBuilder()
    //   .withUrl("http://locahost/notificationHub", {
    //     skipNegotiation: true,
    //     transport: signalR.HttpTransportType.WebSockets
    //   })
    //   .build();

    // this.connection.on("ReceiveNotification", (user, message) => {
    //   this.$toast.success(`Sales order ${message} has been updated!`, { timeout: false });

    //   this.messages.push(`${user}: ${message}`);
    // });

    // this.connection.start()
    //   .catch(err => console.error(err.toString()));

    this.user = JSON.parse(localStorage.getItem("user_data"));
    const observer = new IntersectionObserver(
      ([entry]) => {
        this.isTabsVisible = entry.isIntersecting;
      },
      { rootMargin: '-10px 0px 0px 0px' }
    );
    observer.observe(this.$refs.search);
    eventBus.$on('invoiceSaved', data => {
      this.displayViewDocument = false;

      const invoiceToUpdate = this.tableData.dataSource.find(invoice => invoice.orderId === data.order.orderId);
      if (invoiceToUpdate) {
        invoiceToUpdate.status = data.order.status;
        invoiceToUpdate.salesPrice = data.order.salesPrice;
        invoiceToUpdate.costPrice = data.order.costPrice;
        invoiceToUpdate.invoiceDate = data.order.invoiceDate;
        invoiceToUpdate.invoiceNumber = data.order.invoiceNumber;
        invoiceToUpdate.invoiceReceivedDate = data.order.invoiceReceivedDate;
        invoiceToUpdate.loadDate = data.order.loadDate;
      }
    });

    eventBus.$on('cancel', () => {
      this.displayViewDocument = false;
    });

    eventBus.$on('closeEditStatus', () => {
      this.displayBulkEdit = false;
    });

    eventBus.$on('closeEditExported', () => {
      this.displayExportToExistingInvoiceModal = false;
    });

    eventBus.$on('closeExportedReadOnly', () => {
      this.displayExportedPastelInvoicesReadOnlyModal = false;
    });

    eventBus.$on('closeEditExportedSuccess', (data) => {
      var accountType = this.currentTab == "receivable" ? "AR Exported" : "AP Exported";
      this.updateAllExportedInvoices(accountType, data);
      this.displayExportToExistingInvoiceModal = false;
    });

    eventBus.$on('statusesSaved', data => {
      this.displayBulkEdit = false;

      data.statuses.forEach(statusUpdate => {
        const invoiceToUpdate = this.tableData.dataSource.find(invoice => invoice.orderId === statusUpdate.orderId);

        if (invoiceToUpdate) {
          invoiceToUpdate.status = statusUpdate.status;
        } else {
          console.warn('Order ID not found in dataSource:', statusUpdate.orderId);
        }
      });

      console.log('Event received, statuses updated:', data.statuses.map(status => status.orderId));
    });

    this.getCustomers();
    // throw new Error('This is a simulated Vue component error');

  },
  methods: {
    viewOrder(reference) {
      this.selectedOrderReferenceNumber = reference;
      this.displayExportedPastelInvoicesReadOnlyModal = true;
    },
    showAdminOrderControls() {
      return this.user.role.Name === 'LcsUser' || this.user.role.Name === 'Admin'
    },
    showContextMenu(event) {
      if (this.user != null && this.user.role.Name === 'Admin') {
        event.preventDefault();
        console.log(this.user)
        const menuItems = [
          ...(this.selectedLoadToEdit && this.selectedLoadToEdit == this.selectedRow.loadConfirmationNumber ? [
            { label: 'Save', action: 'save', row: this.selectedRow }
          ] : [
            { label: 'Edit', action: 'edit', row: this.selectedRow }
          ]),
          { label: 'Cancel', action: 'cancel', row: this.selectedRow }
        ];

        if (!this.disableRightClick) {
          this.$refs.contextMenu.showMenu(event, menuItems);
        }
      }
    },
    onRowRightClick(row) {
      if (this.selectedLoadToEdit != null && this.selectedLoadToEdit == row.loadConfirmationNumber) {
        this.selectedRow = row;
        this.disableRightClick = false;
      }

      if (this.selectedLoadToEdit == null) {
        this.selectedRow = row;
        this.disableRightClick = false;
      }

      if (this.selectedLoadToEdit != null && this.selectedLoadToEdit != row.loadConfirmationNumber) {
        this.disableRightClick = true;
      }
    },
    saveRow() {
      api.SetOrderStatus(this.selectedRow)
        .then(() => {
          this.$toast.success('Invoice saved successfully!');
          this.selectedLoadToEdit = null;
          this.selectedRow = null;
          eventBus.$emit('invoiceSaved', { order: this.selectedRow });
        })
        .catch(() => {
          this.undoRowEdit();
          this.$toast.error('Invoice could not be saved!');
        });
    },
    editRow() {
      this.selectedLoadToEdit = this.selectedRow.loadConfirmationNumber;
      this.ogSelectedRow = { ...this.selectedRow };
    },
    undoRowEdit() {
      if (this.selectedRow != null && this.ogSelectedRow != null) {
        this.selectedRow.status = this.ogSelectedRow.status;
        this.selectedRow.pastelSalesOrderReference = this.ogSelectedRow.pastelSalesOrderReference;
        this.selectedRow.pastelPurchaseOrderReference = this.ogSelectedRow.pastelPurchaseOrderReference;
      }
    },
    cancelRowEdit() {
      this.undoRowEdit();
      this.selectedLoadToEdit = null;
      this.selectedRow = null;
    },
    handleMenuAction(event, row) {
      switch (event.action) {
        case 'edit':
          this.editRow(row);
          break;
        case 'save':
          this.saveRow(row);
          break;
        case 'undo':
          this.undoRowEdit(row);
          break;
        case 'cancel':
          this.cancelRowEdit(row);
          break;
        default:
          console.error('Unknown action:', event.action);
      }
    },
    previousYear() {
      if (this.currentYear > 2000) {
        this.currentYear--;
        this.getChartData();
      }
    },
    nextYear() {
      if (this.currentYear < 2050) {
        this.currentYear++;
        this.getChartData();
      }
    },
    capitalizeFirstLetter(str) {
      if (str.length === 0) {
        return str;
      }
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    setVisibility(label, visibility) {
      const column = this.ogTableData.tableColumns.find(col => col.label === label);

      if (column) {
        column.visible = visibility;
        this.tableData.tableColumns = [...this.ogTableData.tableColumns.filter(col => col.visible)];
      }
    },
    toggleVisibility(currentTab) {
      if (currentTab == "receivable") {
        this.setVisibility("Customer Code", true)
        this.setVisibility("Vendor Code", false)
        this.setVisibility("AP Invoice Total", false)
        this.setVisibility("AR Invoice Total", true)
        this.setVisibility("Deemed Invoice Total", false)
        this.setVisibility("SO Reference", true)
        this.setVisibility("PO Reference", false)
        this.purchaseOrderReferenceNumber = null;
        this.setVisibility("", true)
        this.searchAll();
      }
      else if (currentTab == "payable") {
        this.setVisibility("Customer Code", false)
        this.setVisibility("Vendor Code", true)
        this.setVisibility("AP Invoice Total", true)
        this.setVisibility("AR Invoice Total", false)
        this.setVisibility("Deemed Invoice Total", false)
        this.setVisibility("SO Reference", false)
        this.setVisibility("PO Reference", true)
        this.salesOrderReferenceNumber = null;
        this.setVisibility("", true)
        this.searchAll();

      }
      else {
        this.setVisibility("Customer Code", true)
        this.setVisibility("Vendor Code", true)
        this.setVisibility("AP Invoice Total", true)
        this.setVisibility("AR Invoice Total", true)
        this.setVisibility("Deemed Invoice Total", false)
        this.setVisibility("SO Reference", true)
        this.setVisibility("PO Reference", true)
        this.setVisibility("", false)
        this.clearSearch();
      }
    },
    changeTab(currentTab) {
      this.currentTab = currentTab;
      this.toggleVisibility(currentTab);
      this.clearSelect();
    },
    selectAll() {
      this.selectedRows = [];
      this.$refs.invoicesTable.selectAllRows();
    },
    clearSelect() {
      this.selectedRows = [];
      this.$refs.invoicesTable.clearSelected();
    },
    exportToExisting() {
      if (this.selectedRows.length > 0) {
        const firstInvoice = this.selectedRows[0];
        let orderType = ``;

        if (this.currentTab == "receivable") {
          orderType = "SalesOrder";
        } else if (this.currentTab == "payable") {
          orderType = "PurchaseOrder";
        }

        api.GetExportPastelInvoices(firstInvoice.bulkOrderNumber, orderType)
          .then((data) => {
            this.pastelInvoices = data;
            console.log(this.pastelInvoices);
            this.displayExportToExistingInvoiceModal = true;
          })
          .catch((error) => {
            console.log(error)
          });
      }
    },
    updateAllExportedInvoices(status, results) {

      var exportedPastelResults = results.map(item => {
        item.item2.orderState = JSON.parse(item.item2.orderState);
        const descriptions = item.item2.orderState.FinancialLines.map(line => line.Description);
        item.item2.descriptions = descriptions;

        return { orderType: item.item2.orderType, orderIds: descriptions, reference: item.item2.reference };
      });

      this.selectedRows = this.selectedRows.map(invoice => {
        return { ...invoice, status: status };
      });

      this.selectedRows.forEach(statusUpdate => {
        const invoiceToUpdate = this.tableData.dataSource.find(invoice => invoice.orderId === statusUpdate.orderId);

        if (invoiceToUpdate) {
          const matchingResult = exportedPastelResults.find(result =>
            result.orderIds.includes(invoiceToUpdate.orderId)
          );

          if (matchingResult) {
            invoiceToUpdate.status = statusUpdate.status;

            if (matchingResult.orderType == 'SalesOrder') {
              invoiceToUpdate.pastelSalesOrderReference = matchingResult.reference;
            } else if (matchingResult.orderType == 'PurchaseOrder') {
              invoiceToUpdate.pastelPurchaseOrderReference = matchingResult.reference;
            }

            const indexToUnselect = this.tableData.dataSource.findIndex(invoice => invoice.orderId === statusUpdate.orderId);
            this.$refs.invoicesTable.unselectRow(indexToUnselect);
          } else {
            console.warn('Reference not found for Order ID:', statusUpdate.orderId);
          }
        } else {
          console.warn('Order ID not found in dataSource:', statusUpdate.orderId);
        }
      });
    },
    exportToExcel() {
      this.isExportingToExcel = true;
      const searchFilter = this.getFilter();
      searchFilter.accountType = this.currentTab;

      api.ExportToExcel(searchFilter)
        .then((response) => {
          const blob = new Blob([response.data], { type: response.headers['content-type'] });

          const link = document.createElement('a');

          const url = window.URL.createObjectURL(blob);
          link.href = url;

          let fileName = 'invoices.xlsx';

          if (this.currentTab == "receivable") {
            fileName = 'Accounts Receivable.xlsx';
          }

          if (this.currentTab == "payable") {
            fileName = 'Accounts Payable.xlsx';
          }

          if (this.currentTab == "completed") {
            fileName = 'Completed.xlsx';
          }

          link.setAttribute('download', fileName);

          document.body.appendChild(link);

          link.click();

          document.body.removeChild(link);

          window.URL.revokeObjectURL(url);

          this.$toast.success('Invoices ready for download!');
        })
        .catch((error) => {
          console.error('Download error:', error);
          this.$toast.error('Invoice/s export failed!');
        })
        .finally(() => {
          this.isExportingToExcel = false;
        });
    },
    exportToPastel(isMultipleExport) {
      if (this.currentTab == "payable") {
        const patelPurchaseOrders = this.selectedRows.map(item => ({
          ServiceDate: item.orderReceivedDate,
          SupplierCode: item.vendorCode,
          SupplierInvoiceNo: item.invoiceNumber,
          ExternalOrderNo: item.purchaseOrderNumber,
          BillOnQuantity: item.billOnQuantity,
          CostPrice: item.costPrice,
          InvoiceDate: item.orderReceivedDate,
          LoadConfirmationNo: item.orderId,
          BulkOrderNo: item.bulkOrderNumber,
          costPriceTaxRate: item.costPriceTaxRate
        }));

        if (!isMultipleExport) {
          this.isExporting = true;
        } else {
          this.isExportingMultiLine = true;
        }
        api.PurchaseOrderPlaceOrder(patelPurchaseOrders, isMultipleExport)
          .then((results) => {
            this.$toast.success('Invoice/s export successfully!');
            if (!isMultipleExport) {
              this.isExporting = false;
            } else {
              this.isExportingMultiLine = false;
            }
            this.disableMultipleExport = true;
            this.updateAllExportedInvoices('AP Exported', results);
          })
          .catch(() => {
            this.$toast.error('Invoice/s export failed!');
            if (!isMultipleExport) {
              this.isExporting = false;
            } else {
              this.isExportingMultiLine = false;
            }
          });
      } else if (this.currentTab == "receivable") {
        const pastelInvoices = this.selectedRows.map(item => ({
          ServiceDate: item.orderReceivedDate,
          CustomerCode: item.customerCode,
          BillOnQuantity: item.billOnQuantity,
          SalesPrice: item.salesPrice,
          InvoiceDate: item.orderReceivedDate,
          ExternalOrderNo: item.purchaseOrderNumber,
          LoadConfirmationNo: item.orderId,
          BulkOrderNo: item.bulkOrderNumber,
          SalesPriceTaxRate: item.salesPriceTaxRate
        }));

        if (!isMultipleExport) {
          this.isExporting = true;
        } else {
          this.isExportingMultiLine = true;
        }
        api.SalesOrderPlaceOrder(pastelInvoices, isMultipleExport)
          .then((results) => {
            this.$toast.success('Invoice/s export successfully!');
            if (!isMultipleExport) {
              this.isExporting = false;
            } else {
              this.isExportingMultiLine = false;
            }
            this.disableMultipleExport = true;
            this.updateAllExportedInvoices('AR Exported', results);
          })
          .catch(() => {
            this.$toast.error('Invoice/s export failed!');

            if (!isMultipleExport) {
              this.isExporting = false;
            } else {
              this.isExportingMultiLine = false;
            }
          });
      }
    },
    bulkEditStatus() {
      this.displayBulkEdit = true;
    },
    onRowSelected(selectedRows) {
      this.selectedRows = selectedRows;

      if (this.currentTab != "completed") {
        if (this.currentTab == "receivable") {
          this.selectedRows.forEach(selectedRow => {
            const invoiceToUpdate = this.tableData.dataSource.find(invoice => invoice.orderId === selectedRow.orderId);

            if (invoiceToUpdate && (invoiceToUpdate.status === 'Queried' || invoiceToUpdate.status === 'Rejected' || invoiceToUpdate.status === 'AR Exported' || invoiceToUpdate.status === 'AR Invoiced' || invoiceToUpdate.status === 'AP Exported' || invoiceToUpdate.status === 'AP Processed' || invoiceToUpdate.status === 'AR Invoiced - AP Exported' || invoiceToUpdate.status === 'AR Exported - AP Processed' || invoiceToUpdate.status === 'Completed')) {
              const indexToUnselect = this.tableData.dataSource.findIndex(invoice => invoice.orderId === selectedRow.orderId);
              this.$refs.invoicesTable.unselectRow(indexToUnselect);
            }
          });

        } else if (this.currentTab == "payable") {
          this.selectedRows.forEach(selectedRow => {
            const invoiceToUpdate = this.tableData.dataSource.find(invoice => invoice.orderId === selectedRow.orderId);

            if (invoiceToUpdate
              && ((invoiceToUpdate.status !== 'AR Invoiced' && invoiceToUpdate.status !== 'AR Exported'))) {
              const indexToUnselect = this.tableData.dataSource.findIndex(invoice => invoice.orderId === selectedRow.orderId);
              this.$refs.invoicesTable.unselectRow(indexToUnselect);
            }
          });
        }

        if (this.selectedRows.length > 0) {
          if (this.currentTab == "receivable") {
            const validReceivableStatuses = ["Accepted", "Credit Note - AP Processed", "Credit Note - AP Exported"];

            this.disableExport = this.selectedRows.every(invoice => !validReceivableStatuses.includes(invoice.status));
          } else if (this.currentTab == "payable") {
            const validPayableStatuses = ["AR Invoiced", "AR Exported", "AR Invoiced - Unreleased", "AR Invoiced - Unreleased"];

            this.disableExport = this.selectedRows.every(invoice => !validPayableStatuses.includes(invoice.status));
          }

          if (this.selectedRows.length > 1) {
            const firstInvoice = this.selectedRows[0];
            this.disableBulkEdit = !this.selectedRows.every(invoice => invoice.status === firstInvoice.status);
          }

          if (this.selectedRows.length > 1 && this.disableExport == false) {
            const firstInvoice = this.selectedRows[0];
            this.disableMultipleExport = !this.selectedRows.every(invoice => invoice.customerCode === firstInvoice.customerCode && invoice.bulkOrderNumber === firstInvoice.bulkOrderNumber);
            this.disableAddToExistingExport = this.disableMultipleExport;
          }
          else if (this.selectedRows.length == 1 && this.disableExport == false) {
            this.disableAddToExistingExport = this.disableExport;
          }
        } else {
          this.disableBulkEdit = true;
          this.disableExport = true;
          this.disableMultipleExport = true;
          this.disableAddToExistingExport = true;
        }
      }
    },
    openDocumentContent(document) {
      console.log(document);
    },
    documentUpdated() {
      console.log("Test");
    },
    handlePageChange(page) {
      this.currentPage = page;
      this.$nextTick(() => {
        this.searchAll();
      });
    },
    formatDate(uploadDate) {
      if (!uploadDate) {
        return 'N/A';
      }

      const dateObj = new Date(uploadDate);
      const year = dateObj.getFullYear();
      const month = String(dateObj.getMonth() + 1).padStart(2, '0');
      const day = String(dateObj.getDate()).padStart(2, '0');

      return `${year}/${month}/${day}`;
    },
    toggleViewDocument(document) {
      if (document) {
        this.selectedInvoiceId = document.orderId;
      } else {
        this.selectedInvoiceId = null;
      }
      this.displayViewDocument = !this.displayViewDocument;
    },
    onDateSelected(dateSelected) {
      this.startDate = dateSelected.startDate;
      this.endDate = dateSelected.endDate;
    },
    clearSearch() {
      this.startDate = null;
      this.endDate = null;
      this.orderIdQuery = null;
      this.selectedVendorId = null;
      this.selectedCustomerId = null;
      this.selectedStatus = null;
      this.purchaseOrderQuery = null;
      this.vehicleRegQuery = null;
      this.bulkOrderQuery = null;
      this.orderKeyQuery = null;
      this.salesOrderReferenceNumber = null;
      this.purchaseOrderReferenceNumber = null;
      this.weighbrideSlipNumber = null;
      this.currentPage = 1;
      this.cancelRowEdit();
      this.getInvoices({});
    },
    getChartData() {
      const searchFilter = this.getFilter();
      searchFilter.accountType = this.currentTab;

      api.GetInvoiceChartData(this.currentYear, searchFilter, (result) => {
        this.chart.data.labels = result.months;

        const datasets = Object.keys(result.statusSums).map(status => ({
          label: this.chart.datasetLabels[status] || status,
          backgroundColor: this.chart.datasetColor[status] || '#000000',
          data: result.statusSums[status],
          barThickness: 10,
        }));

        this.chart.data.datasets = datasets;

        this.chart.options = {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            y: {
              ticks: {
                callback: function (value) {
                  return new Intl.NumberFormat('en-ZA', {
                    style: 'currency',
                    currency: 'ZAR'
                  }).format(value);
                }
              }
            }
          }
        };

      }, this.printError);
    },
    searchAll() {
      const searchFilter = this.getFilter();
      this.getInvoices(searchFilter);
    },
    getFilter() {
      return { sortBy: this.sortBy, sortDesc: this.sortDesc, orderKey: this.orderKeyQuery, weighbrideSlipNumber: this.weighbrideSlipNumber, vehicleReg: this.vehicleRegQuery, bulkOrderNumber: this.bulkOrderQuery, salesOrderReferenceNumber: this.salesOrderReferenceNumber, purchaseOrderReferenceNumber: this.purchaseOrderReferenceNumber, date: "", startDate: this.startDate, endDate: this.endDate, orderId: this.orderIdQuery, purchaseOrderNumber: this.purchaseOrderQuery, vendorId: this.selectedVendorId, customerId: this.selectedCustomerId, statusDescription: this.selectedStatus, pageNumber: this.currentPage };
    },
    setDate(date) {
      this.selectedDate = date
      // Reload data and filters
      this.getInvoices({})
    },
    getCustomers() {
      api.GetCustomers(data => {
        this.customers = data.slice().sort((a, b) => a.name.localeCompare(b.name));
      },
        console.error)
    },
    getVendors() {
      api.GetVendors(data => {
        this.vendors = data.slice().sort((a, b) => a.name.localeCompare(b.name));
      },
        console.error)
    },
    mobileAndTabletCheck() {
      // let check = false;

      if (screen.width <= 788) {
        return true
      } else {
        return false
      }
      // eslint-disable-next-line
      // let check = (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
      //
      //
      // return check;
    },
    forceRerender() {
      this.componentKey += 1;
    },
    getInvoices(searchFilter) {
      //Get Invoices by date
      if (this.CanViewAll) {
        this.tableData.isLoading = true;
        searchFilter.accountType = this.currentTab;
        api.GetInvoiceDataAll(searchFilter, (result) => {
          this.tableData.dataSource = result.data;
          this.totalNoDocuments = result.totalPages * this.tableData.resultsPerPage;
          this.tableData.isLoading = false;
        }, this.printError)

        this.getChartData();
      }
      else {
        api.GetVendorFromId(this.user.Vendor, x => {

          // var id = x.id ?? ""
          if (x.id === undefined) {
            this.makeToast("User Account Error", "User not part of Vendor Entity", 'danger')
            // alert("Your not part of a company. Please contact support")

          }
        }, this.printError)

      }

    },
    printError(err) {
      this.makeToast("Invoice Tracker", err, 'danger')
    },
    getInvoiceText(f) {

      if (f.view === "") {
        console.log("Empty show add invoice popup")
        return "Add"
      }

      return f.view
    },
    onRowClick(row) {
      this.selectedInvoiceId = row.orderId;
      this.displayViewDocument = !this.displayViewDocument;
    },
    getOrderDates(day) {
      if (this.availableDates === null)
        return 0

      return this.availableDates[day.toLocaleDateString()]
    },

  }
  ,
  created() {
    this.ogTableData = { ...this.tableData };

    this.toggleVisibility(this.currentTab);
    this.user = JSON.parse(localStorage.getItem("user_data"));


    if (this.mobileAndTabletCheck()) {
      this.hidden = true;

    }

    this.setDate(new Date())

    this.getVendors();
  }
}
</script>

<style>
.admin-inline-status .custom-select {
  width: 100px;
  height: 25px;
  font-size: 0.85rem;
}

.admin-inline-reference input {
  width: 75px;
  height: 25px;
}

.year-navigator {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.nav-button {
  padding: 5px 5px;
  border: none;
  background-color: #ccc;
  color: #040910;
  background-color: transparent;
  border-color: #040910;
  cursor: pointer;
}

.current-year {
  font-size: 1.2em;
  font-weight: bold;
}

.floating-buttons {
  position: fixed;
  top: 71px;
  left: 0;
  width: 100%;
  background-color: white;
  z-index: 1000;
  box-shadow: 0px 4px 2px -2px gray;
  padding: 10px 15px;
  transition: transform 0.3s cubic-bezier(0.68, -0.55, 0.27, 1.55), opacity 0.3s ease;
}

.calBox {
  flex: 0 0 230px;
  max-width: 230px;
}

.chartBox {
  /*height: 100px;*/
  min-height: 100px;
  max-width: 1200px !important;
}

/* .b-table-row-selected {
  background-color: #ffcb14 !important;
  border-color: #ffcb14 !important;
} */

.table-active {
  background-color: #00AEEF !important;
  border-color: #00AEEF !important;
  color: #fff;
}

.table th {
  padding: 0.70rem !important;
}

.tabs button {
  padding: 10px 20px;
  cursor: pointer;
  outline: none;
  background-color: #e0e0e0;
  border: 1px solid #ccc;
}

.tabs button.active {
  background-color: #f9f9f9;
}

table th {
  padding: 0px !important;
  font-size: 0.8rem;
  white-space: nowrap !important;
}

table td {
  padding-top: 0.4rem !important;
  padding-bottom: 0.4rem !important;
  padding-right: 0px !important;
  font-size: 0.8em;
}

.table.b-table>thead>tr>th,
.table.b-table>tfoot>tr>td {
  background-image: none !important;
}

.table-card .card-body {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.table-container {
  position: relative;
  overflow-x: auto;
}
</style>